module.exports = __webpack_public_path__ + "img/horizontal_4_7_6000.58f8f9e1.png";